import {IDMap, KeyMap, ModelID} from "../generic-types";
import {ConstantProperty} from "../../_models/constant-property";
import {ComponentType} from "../../_models/component-type";
import {EventConfigColumn} from "./config-column";
import {ColumnFormatsConfigDict} from "../../forms/table-column-menu/table-column-menu.component";
import {IPendingContextConfig} from "../../forms/pending-context-form/pending-context-form.component";
import {IComponentTypeNameFormulaConfig} from "./component-name-formula-config";
import {ConfigStub} from "../config-stub";
import {WireComponent} from "../../_models/component";
import {ConfigTypeDateFilter} from "./config-type-date-filter";
import {RuleSet, WireRuleSet} from "../query-builder";
import {FileDownloadOption} from "../download-filetype";
import {LockTemplate} from "../../_models/lock-template";
import {ConditionalFormattingConfig} from "../../services/conditional-formatting.service";
import {ExportComponentConfig} from "../../forms/component-events-table-form/component-events-table-form.component";

export function isComponentEventsConfig(config: unknown): config is COMPONENT_EVENTS_CONFIG {
    return (
        config !== null &&
        typeof config === 'object' &&
        'selected_component_type' in config
    );
}


export interface ISelectedColsType {
    'component_type': EventConfigColumn[];
    'event': EventConfigColumn[];
    'component': KeyMap<EventConfigColumn[]>;
}

interface RelationshipsAttributes {
    show: boolean;
    unique_property: ModelID;
    pending_context: IPendingContextConfig;
}

interface IComponentEventsConfig extends IComponentTypeNameFormulaConfig {
    columns: EventConfigColumn[];
    can_create_component: boolean;
    selected_component_type: ConfigStub<ComponentType>;
    selected_component_relationship_types: ComponentType[];
    component: WireComponent;
    selected_cols: ISelectedColsType;
    relationships: Record<string, Partial<RelationshipsAttributes>>;
    start_prop: string;
    end_prop: string;
    component_type_date_filters: Partial<ConfigTypeDateFilter>;
    printout: boolean;
    search: boolean;
    search_by_name: boolean;
    constant_property_time: boolean;
    name_must_contain: string;
    filter_by_created_on: boolean;
    exclude_null_start: boolean;
    exclude_null_end: boolean;
    include_null_constant_dates: boolean;
    bypass_limits_formatting: boolean;
    bypass_date_filters: boolean;
    bypass_limits_validation: boolean;
    allow_unlink: boolean;
    allow_unlink_components: boolean;
    column_formats: ColumnFormatsConfigDict;
    component_column_formats: Record<string, ColumnFormatsConfigDict>;
    event_column_formats: Record<string, ColumnFormatsConfigDict>;
    show_aggregations: boolean;
    show_aggregations_top: boolean;
    show_audit: boolean;
    show_calc_update_status: boolean;
    page_size: number;
    query: RuleSet;
    filter: RuleSet;
    enable_row_selection: boolean;
    enable_export_component: ExportComponentConfig[];
    constrain_width: boolean;
    row_height: number | 'auto';
    aggregation_top_row_height: number | 'auto';
    aggregation_bottom_row_height: number | 'auto';
    detail_row_height: number | 'auto';
    scroll_top: boolean;
    download_file_type: FileDownloadOption;
    conditional_formats: ConditionalFormattingConfig[];
    lock_template: ConfigStub<LockTemplate>;
    printouts: ModelID[];
    validation: WireRuleSet | null;
}

export type COMPONENT_EVENTS_CONFIG = Partial<IComponentEventsConfig>;

export type ComponentEventsColumnType = ComponentType | ConstantProperty;
export type ComponentEventsConfigColumnKey = 'component_type' | 'event' | 'component';
